export const categoriesDate = [
    { "id": 1, "original": "A Hand", "translation": "Une Main" },
    { "id": 2, "original": "Accountant and Bookkeeping", "translation": "Services de comptabilité et de tenue de livres" },
    { "id": 3, "original": "Appliance Repair", "translation": "Réparation d'appareils" },
    { "id": 4, "original": "Automotive Detailing and Vehicle Repair", "translation": "Détail automobile et réparation de véhicules" },
    { "id": 5, "original": "Architectural Design", "translation": "Conception architecturale" },
    { "id": 6, "original": "AC installation and repaire", "translation": "Installation et réparation de climatisation" },
    { "id": 7, "original": "AI Services", "translation": "AI Services" },

    { "id": 20, "original": "Babysitting and Childcare", "translation": "Babysitting et garde d'enfants" },
    { "id": 21, "original": "Bartender", "translation": "Bartender" },
    { "id": 22, "original": "Blockchain Developer", "translation": "Développeur Blockchain" },
    { "id": 23, "original": "Bicycle Repair", "translation": "Réparation de vélos" },
    { "id": 24, "original": "Buyer", "translation": "Acheteur/Acheteuse" },
    { "id": 25, "original": "Bouncer", "translation": "Videur/Videuse" },

    { "id": 40, "original": "Carpentry and Woodworking", "translation": "Menuiserie et travail du bois" },
    { "id": 41, "original": "Catering", "translation": "Service de traiteur" },
    { "id": 42, "original": "Caregiver", "translation": "Soignant/Soignante" },
    { "id": 43, "original": "Computer Programming", "translation": "Programmation informatique" },
    { "id": 44, "original": "Computer Repair and IT", "translation": "Réparation informatique et services informatiques" },
    { "id": 45, "original": "Copywriting and Content Creation", "translation": "Rédaction et création de contenu" },
    { "id": 46, "original": "Cleaning and Housekeeping", "translation": "Nettoyage et entretien ménager" },
    { "id": 47, "original": "Cyber Security", "translation": "Sécurité Informatique" },
    { "id": 48, "original": "C# Programming", "translation": "Programmation C#" },
    { "id": 49, "original": "Customer Service Agent", "translation": "Agent de service à la clientèle" },
    { "id": 50, "original": "Clown", "translation": "Clown" },

    { "id": 60, "original": "Dog Walking and Pet Care", "translation": "Promenade de chiens et soins des animaux" },
    { "id": 61, "original": "Dry Cleaning and Laundry", "translation": "Nettoyage à sec et services de blanchisserie" },
    { "id": 62, "original": "Data entry clerk", "translation": "Saisie de données Commis" },
    { "id": 63, "original": "Data Analyst", "translation": "Analyste de données" },
    { "id": 64, "original": "DevOps Engineer", "translation": "Ingénieur DevOps" },
    { "id": 65, "original": "Dance Instructor", "translation": "Professeur de danse" },

    { "id": 80, "original": "Electrician", "translation": "Services d'électricien" },
    { "id": 81, "original": "Event Planning & Wedding Planning", "translation": "Planification d'événements et organisation de mariages" },
    { "id": 82, "original": "Empathetic Listener", "translation": "Écoute Empathique" },
    { "id": 83, "original": "English Teacher", "translation": "Professeur d'anglais" },
    { "id": 84, "original": "E-Commerce", "translation": "E-Commerce" },

    { "id": 101, "original": "Farming and Agriculture", "translation": "Agriculture et élevage" },
    { "id": 102, "original": "Financial Planning", "translation": "Planification financière" },
    { "id": 103, "original": "French Teacher", "translation": "Professeur de français" },

    { "id": 121, "original": "Florist", "translation": "Fleuriste et arrangements floraux" },
    { "id": 122, "original": "Furniture Assembly", "translation": "Assemblage de meubles" },
    { "id": 123, "original": "Furniture Repair and Restoration", "translation": "Réparation et restauration de meubles" },
    { "id": 124, "original": "Food Delivery", "translation": "Livraison de nourriture" },

    { "id": 141, "original": "Gardening and Landscape Design", "translation": "Jardinage et conception de paysages" },
    { "id": 142, "original": "Graphic Design", "translation": "Design graphique et illustration" },
    { "id": 143, "original": "Guitar Instructor", "translation": "Professeur de guitare" },
    { "id": 144, "original": "General Assistant", "translation": "Assistant général" },
    { "id": 145, "original": "General Labour", "translation": "Travail général" },
    { "id": 146, "original": "Golf Instructor", "translation": "Instructeur de golf" },

    { "id": 161, "original": "Hair Stylist and Beauty", "translation": "Coiffure et Beauté" },
    { "id": 162, "original": "Handyman", "translation": "Services de bricolage" },
    { "id": 163, "original": "Home Renovation", "translation": "Rénovation de maison" },
    { "id": 164, "original": "Hockey/Skating instuctor", "translation": "Instructeur de hockey/patinage" },

    { "id": 181, "original": "Interior Design", "translation": "Design d'intérieur" },

    { "id": 201, "original": "Lawyer", "translation": "Avocat" },
    { "id": 202, "original": "Locksmith", "translation": "Services de serrurier" },
    { "id": 203, "original": "Language Teacher", "translation": "Enseignant de Langues" },

    { "id": 221, "original": "Marketing and Advertising", "translation": "Marketing et publicité" },
    { "id": 222, "original": "Massage Therapy", "translation": "Thérapie de massage" },
    { "id": 223, "original": "Moving and Transportation", "translation": "Déménagement et transport" },
    { "id": 224, "original": "Makeup artist", "translation": "Maquilleuse/Maquilleur" },
    { "id": 225, "original": "Mathematics Teacher", "translation": "Professeur de mathématiques" },
    { "id": 226, "original": "Magician", "translation": "Magicien/Magicienne" },
    { "id": 227, "original": "Mobile repair", "translation": "Réparation mobile" },
    { "id": 228, "original": "Mobile app development", "translation": "Développement d'applications mobiles" },

    { "id": 241, "original": "Nutritionist", "translation": "Nutritionniste" },
    { "id": 242, "original": "Nail Technician", "translation": "Technicienne en pose d'ongle" },

    { "id": 261, "original": "Painting and Wall Art", "translation": "Peinture et art mural" },
    { "id": 262, "original": "Personal Shopping", "translation": "Shopping personnel" },
    { "id": 263, "original": "Photography and Videography", "translation": "Photographie et vidéographie" },
    { "id": 264, "original": "Plumbing", "translation": "Services de plomberie" },
    { "id": 265, "original": "Personal Trainer", "translation": "Fitness et entraînement personnel" },
    { "id": 266, "original": "Piano Instructor", "translation": "Professeur de piano" },
    { "id": 267, "original": "Painting and Drawing", "translation": "Peindre et dessiner" },
    { "id": 267, "original": "Psychologist", "translation": "Psychologue" },

    { "id": 281, "original": "Quality Assurance", "translation": "Assurance qualité" },

    { "id": 301, "original": "Real Estate Services", "translation": "Services immobiliers" },
    { "id": 302, "original": "Roofing and Roof Repair", "translation": "Toiture et réparation de toits" },
    { "id": 303, "original": "Recruiter/HR", "translation": "Recruteur/Recruteuse/RH" },

    { "id": 321, "original": "Sewing and Tailoring", "translation": "Couture et retouches" },
    { "id": 322, "original": "Security Guard", "translation": "Agent de sécurité" },
    { "id": 323, "original": "Social Media Management", "translation": "Gestion des médias sociaux" },
    { "id": 324, "original": "Spa Services", "translation": "Services de spa" },
    { "id": 325, "original": "Snow Removal", "translation": "Déneigement" },
    { "id": 326, "original": "Sales/Business Development", "translation": "Ventes/Développement des affaires" },
    { "id": 327, "original": "Ski/Snowboarding inctructor ", "translation": "Instructeur de ski/snowboard" },
    { "id": 328, "original": "Swimming Instructor", "translation": "Moniteur de natation" },
    { "id": 329, "original": "Singer/Band", "translation": "Chanteur/Chanteuse/Groupe" },

    { "id": 351, "original": "Technical Support", "translation": "Support technique" },
    { "id": 352, "original": "Tutoring and Education", "translation": "Tutorat et éducation" },
    { "id": 353, "original": "Translation", "translation": "Traduction" },
    { "id": 354, "original": "Tattoo Artist", "translation": "Tatoueur" },
    { "id": 355, "original": "Tennis Instructor", "translation": "Instructeur de Tennis" },

    { "id": 370, "original": "UI/UX", "translation": "UI/UX" },

    { "id": 381, "original": "Web Development", "translation": "Développement web" },
    { "id": 382, "original": "Welding and Metalwork", "translation": "Soudure et travail des métaux" },
    { "id": 383, "original": "Window Cleaning", "translation": "Nettoyage de vitres" },
    { "id": 384, "original": "Waiter/Waitress", "translation": "Serveur/Serveuse" },


    { "id": 404, "original": "Yoga and Fitness Instruction", "translation": "Instruction de yoga et de fitness" }
]